import { Stack, Typography } from '@mui/material';
import { useLocalization } from 'localization';

type Props = {
  title: string;
  caseId: string;
};

const TaskModalTitle = (props: Props) => {
  const { title, caseId } = props;
  const { t } = useLocalization();

  return (
    <Stack direction="column" gap={1}>
      <Typography variant="h4" lineHeight={'1.25'}>
        {title}
      </Typography>
      <Typography variant="body2">
        {t('common.terms.case')}: {caseId}
      </Typography>
    </Stack>
  );
};

export default TaskModalTitle;
